const Colors = {
  HWK_RED: "#e0101e",
  HWK_BLACK: "#242d2a",

  WHITE: "#ffffff",

  GREY_0: "#fafafc",
  GREY_1: "#e9e8ef",
  GREY_2: "#dedde3",
  GREY_3: "#979797",

  BLACK_0: "#000000",
  BLACK_1: "#0e1211",
  BLACK_2: "#151d1a",

  LEGEND_BLUE: "#4ca9d6",
  LEGEND_RED: "#e0101e",
  LEGEND_YELLOW: "#e9ba39",

  SNOW_TYPE_COLOR: "#979797",
};

export default Colors
